import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=5f568282&"
import script from "./basic.ts?vue&type=script&lang=ts&"
export * from "./basic.ts?vue&type=script&lang=ts&"
import style0 from "./basic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports